import * as Backbone from "backbone";

export class DashboardCategory extends Backbone.Model {
    
    url = (): string => {
        const collection = this.collection as any;
        if (!collection || !this.get('id')) {
            // Fallback to default Backbone behavior if no collection or no ID
            const baseUrl = (Backbone.Model.prototype as any).url.call(this);
            return typeof baseUrl === 'string' ? baseUrl : '';
        }
        
        // Build URL with category ID in path before query parameters
        const baseUrl = collection.url();
        const queryIndex = baseUrl.indexOf('?');
        let url: string;
        
        if (queryIndex !== -1) {
            // Insert category ID before the query string
            url = baseUrl.substring(0, queryIndex) + '/' + this.get('id') + baseUrl.substring(queryIndex);
        } else {
            // No query string, just append category ID
            url = baseUrl + '/' + this.get('id');
        }
        
        return url;
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/models/DashboardCategory.ts